<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;
      My Pending Approvals</h5>
  </div>

<div id="mainContent" class="container">
 <div class="row pt-3">
    <div class="col-md-12">
      <table class="table table-sm table-bordered table-striped">
        <!-- style="display: block; overflow-x: auto; white-space: nowrap" -->
        <thead class="">
          <tr>
            <th></th>
            <th></th>
            <th></th>
            <th>Status</th>
            <th>Employee Name</th>
            <th>Approver Name</th>
            <th>Documents</th>
            <th>Entry Date</th>
            <th>Client</th>
            <th>Assignment</th>
            <th>Financial Year</th>
            <th>From Date</th>
            <th>To Date</th>
            <th>Total</th>
            <th>Remark</th>
          </tr>
        </thead>
        <tbody *ngFor="let travelsheet of pendingTravelSheetList">
          <tr>
            <td>
              <a
                style="color: #800000; cursor: pointer;text-decoration: underline;"
                (click)="ViewTravelSheet(travelsheet, viewModalContent)"
              >
                View Details
              </a>
            </td>
            <td>
              <a
                style="color: #800000; cursor: pointer;text-decoration: underline;"
                (click)="approvedTravelSheet(travelsheet)"
              >
                Approve
              </a>
            </td>
            <td>
              <a
                style="color: #800000; cursor: pointer;text-decoration: underline;"
                (click)="openResendModal(resendModalContent,travelsheet)"
              >
                Resend
              </a>
            </td>
            <td>{{ travelsheet.sheetStatus }}</td>
            <td>
              {{ travelsheet.user.firstName }}
              {{ travelsheet.user.middleName }} {{ travelsheet.user.lastName }}
            </td>
            <td>
              {{ travelsheet.approver.firstName }}
              {{ travelsheet.approver.middleName }}
              {{ travelsheet.approver.lastName }}
            </td>
            <td>
              <a
                style="color: #800000; cursor: pointer;text-decoration: underline;"
                (click)="
                  openDocumentModal(modalContent, travelsheet.fareDocuments)
                "
              >
                Documents
              </a>
            </td>
            <td>
              {{ travelsheet.entryDate | date: "dd-MMMM-yyyy" }}
            </td>
            <td>{{ travelsheet.client.name }}</td>
            <td>{{ travelsheet.assignment.name }}</td>
            <td>{{ travelsheet.fy.name }}</td>
            <td>
              {{ travelsheet.fromDate | date: "dd-MMMM-yyyy" }}
            </td>
            <td>
              {{ travelsheet.toDate | date: "dd-MMMM-yyyy" }}
            </td>
            <td>{{ travelsheet.totalAmount }}</td>
            <td>{{ travelsheet.remark }}</td> 
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>

<ng-template #modalContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt pt-2 pb-2">
    <h5 class="modal-title" id="modal-basic-title">Perticular Documents</h5>
  </div>
  <div class="modal-body">
    <table class="table table-fixed table-bordered">
      <thead>
        <th>Type</th>
        <th>Name</th>
        <th>Url</th>
      </thead>
      <tbody *ngFor="let document of fareDocumentsList; let i = index">
        <td>{{ document.type }}</td>
        <td>{{ document.name }}</td>
        <td >
          <a href="{{ document.url }}" target="_blank" rel="noopener noreferrer"
            ><i class="fa fa-download fa-lg" style="color:#800000"></i
          ></a>
        </td>
      </tbody>
    </table>
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-9"></div>
      <div class="col-sm-3">
        <button
          id="closeStandardBtn"
          name="closeStandardBtn"
          type="button"
          class="btn btn-sm btn-block btn-outline-secondary"
          (click)="modal.dismiss('Cross click')"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #viewModalContent let-modalView>
  <div class="modal-header bg-theme bg-theme-txt pt-2 pb-2">
    <h5 class="modal-title" id="modal-basic-title">View Travel Sheet</h5>
  </div>
  <div class="modal-body">
    <div class="row mb-1">
      <div class="col-sm-3"><label>Approver Name</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span
          >{{ travelSheetModel.approver.firstName }}
          {{ travelSheetModel.approver.middleName }}
          {{ travelSheetModel.approver.lastName }}
        </span>
      </div>
      <div class="col-sm-3"><label>Date </label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.entryDate | date: "dd-MMMM-yyy" }} </span>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-sm-3"><label>Client Name</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.client.name }}</span>
      </div>
      <div class="col-sm-3"><label>Chargable To Client</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.chargeble == true ? "Yes" : "No" }}</span>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-sm-3"><label>Assignment</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.assignment.name }}</span>
      </div>
      <div class="col-sm-3"><label>Financial Year</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.fy.name }}</span>
      </div>
    </div>

    <div class="row mb-1">
      <div class="col-sm-3"><label>From Date</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.fromDate | date: "dd-MMMM-yyy" }} </span>
      </div>
      <div class="col-sm-3"><label>To Date</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>
          {{ travelSheetModel.toDate | date: "dd-MMMM-yyy" }}
        </span>
      </div>
    </div>

    <div class="row mb-1">
      <div class="col-sm-3">
        <label>No Of Persons</label>
      </div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.noOfPersons }}</span>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-md-3">
        <label class="col-form-label">Particulars</label>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-sm-3"><label>Train Amount</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.trainAmount }}</span>
      </div>
      <div class="col-sm-3"><label>Air Amount</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span> {{ travelSheetModel.airAmount }}</span>
      </div>
    </div>

    <div class="row mb-1">
      <div class="col-sm-3"><label>Taxi Amount</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.taxiAmount }}</span>
      </div>
      <div class="col-sm-3"><label>Car Amount</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span> {{ travelSheetModel.carAmount }}</span>
      </div>
    </div>

    <div class="row mb-1">
      <div class="col-sm-3"><label>Toll Amount</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.toll }}</span>
      </div>
      <div class="col-sm-3"><label>Hotel Stay Amount</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span> {{ travelSheetModel.hotelAmount }}</span>
      </div>
    </div>

    <div class="row mb-1">
      <div class="col-sm-3"><label>Food Expense Amount</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.foodAmount }}</span>
      </div>
      <div class="col-sm-3"><label>Mobile Amount</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.mobileAmount }}</span>
      </div>
    </div>

    <div class="row mb-1">
      <div class="col-sm-3"><label>Internet Amount</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.internetAmount }}</span>
      </div>
      <div class="col-sm-3"><label>ICAI Membership fee</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span> {{ travelSheetModel.icaiMembershipFee }}</span>
      </div>
    </div>

    <div class="row mb-1">
      <div class="col-sm-3"><label>Microsoft 365 Subscription</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.microsoft365Subscription }}</span>
      </div>
      <div class="col-sm-3"><label>Seminar Fee</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span> {{ travelSheetModel.seminarFee }}</span>
      </div>
    </div>
    <hr />
    <div class="row mb-1">
      <div class="col-sm-3"><label>Others Amount</label></div>
      <div class="col-sm-9">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.otherAmount }} </span>
      </div>
      <div class="col-sm-3"><label>Nature Of Expense</label></div>
      <div class="col-sm-9">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.natureOfExpense }} </span>
      </div>
    </div>
    <hr />
    <div class="row mb-1">
      <div class="col-sm-3"><label>Total Amount</label></div>
      <div class="col-sm-9">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.totalAmount }} </span>
      </div>
    </div>

    <div class="row mb-1">
      <div class="col-sm-3"><label>Advance Taken Amount</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.advanceTaken }}</span>
      </div>
      <div class="col-sm-3"><label>Advance Approver</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span *ngIf="travelSheetModel.advanceApprover!=null">{{ travelSheetModel.advanceApprover.firstName}} {{ travelSheetModel.advanceApprover.middleName}} {{ travelSheetModel.advanceApprover.lastName}}</span>
      </div>
    </div>

    <div class="row mb-1">
      <div class="col-sm-3"><label>Net payable / receivablet</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.netPayable | number: "1.2-2"}}</span>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-sm-3"><label>Remark</label></div>
      <div class="col-sm-9">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ travelSheetModel.remark }} </span>
      </div>
    </div>
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-9"></div>
      <div class="col-sm-3">
        <button
          id="closeAssignmentBtn"
          name="closeAssignmentBtn"
          type="button"
          class="btn btn-sm btn-block btn-outline-secondary"
          (click)="modalView.dismiss('Cross click')"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #resendModalContent let-modal>
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-12">
        <h6>Please Enter Reason :</h6>
      </div>
    </div>
   <div class="row">
     <div class="col-sm-12">
       <textarea type="text"
       class="form-control"
       id="resendReason"
       name="resendReason"
       [(ngModel)]="resendReasonText"
       ></textarea>
     </div>
   </div>
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-6"></div>
      <div class="col-sm-3">
        <button
          id="closeStandardBtn"
          name="closeStandardBtn"
          type="button"
          class="btn btn-sm btn-block btn-theme"
          (click)="resendTravelSheet()"
        >
          ok
        </button>
      </div>
      <div class="col-sm-3">
        <button
          id="closeStandardBtn"
          name="closeStandardBtn"
          type="button"
          class="btn btn-sm btn-block btn-outline-secondary"
          (click)="modal.dismiss('Cross click')"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>